import { useState, useRef } from 'react';
import {
  KnockFeedProvider,
  NotificationIconButton,
  NotificationFeedPopover,
} from '@knocklabs/react';

import { useClientEnvs } from '@/hooks/api/use-client-envs/use-client-envs';
import '@knocklabs/react/dist/index.css';
import { KNOCK_FEED_ID } from '@/env-variables';

interface KnockNotificationFeedProps {
  darkMode?: boolean;
}

export function KnockNotificationFeed({
  darkMode = false,
}: KnockNotificationFeedProps) {
  const { data: clientEnvs } = useClientEnvs();
  const [isVisible, setIsVisible] = useState(false);
  const notifButtonRef = useRef(null);

  return (
    <KnockFeedProvider
      feedId={clientEnvs.knockFeedId ?? KNOCK_FEED_ID}
      colorMode={darkMode ? 'dark' : 'light'}
    >
      <NotificationIconButton
        ref={notifButtonRef}
        onClick={() => setIsVisible(!isVisible)}
        aria-label="open notification menu"
      />
      <NotificationFeedPopover
        buttonRef={notifButtonRef}
        isVisible={isVisible}
        onClose={() => setIsVisible(false)}
      />
    </KnockFeedProvider>
  );
}
